import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {Button} from 'primeng/button';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'homey-copy-button',
  imports: [Button],
  templateUrl: './copy-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyButtonComponent {
  private readonly messageService = inject(MessageService);
  public readonly value = input.required<string>();

  onClick() {
    navigator.clipboard.writeText(this.value()).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Copied to clipboard',
        detail: this.value(),
      });
    });
  }
}
